import { useGet } from '../../HttpClient';
import { productBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

const pillarCode = "tms";
 
type ProductConfig = {
  [serviceName: string]: { [key: string]: any };
};

export function useProductConfig({ productId }: { productId: string }) {
  const get = useGet(true, pillarCode);
  const getProductConfig = (productId: string) => get<ProductConfig>(`${productBaseUrl}/product/${productId}/config`);

  return useQueryWithErrorHandling({
    queryKey: ['products', productId],
    queryFn: async () => await getProductConfig(productId),
    enabled: !!productId,
  });
}
